import { render, staticRenderFns } from "./spaModal.vue?vue&type=template&id=27ed7bbd&scoped=true"
import script from "./spaModal.vue?vue&type=script&lang=js"
export * from "./spaModal.vue?vue&type=script&lang=js"
import style0 from "./spaModal.vue?vue&type=style&index=0&id=27ed7bbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ed7bbd",
  null
  
)

export default component.exports